module.exports = __webpack_public_path__ + "static/img/mini.fae1617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mini.jpg
// module id = pzCH
// module chunks = 92